import React from 'react';
import {AppHelmet, AppWrapper, baseUrl, baseRealtyUrl, baseRealEstateUrl, getUrlWithUtmQueryString } from '@capcenter/shared';
import {
  GlobalIcons,
  ImageCapCenterHQ,
  ImageSmores2,
  ImageSmores,
  ImageGlenAllenVA,
  ImageGlenAllenVA2,
  ImageGlenAllenVAPieDay,
  ImageGlenAllenVAPieDay2,
  ImageGlenAllenVAPieDay3,
  ImageGlenAllenVAPieDay4,
  ImageGlenAllenVAHalloweenTeam,
  ImageGlenAllenVAHalloween,
  ImageRichmondRaceway
} from '@capcenter/shared-legacy';
import {ImageGlenAllenOffice} from '@capcenter/shared-service-map';
import './Locations.scss';
import getElasticSearchListings from '../Utilities/GetElasticSearchListings';
import buildListingURL from '../Utilities/BuildURLString';


GlobalIcons();

function State(
  props: any
) {
  const [renderedHtmlListings, setRenderedHtmlListings] = React.useState<Array<any>>([]);
  const [initialized, setInitialized] = React.useState<boolean>(false);
  let htmlListings: any = [];

  async function getListings(state: string) {
    const response = await getElasticSearchListings({isRealty: props.custom.isRealty, state: state});
    return response.json();
  };

  function buildListingLinkText(listingSource: any) {
    const addressLineOne = listingSource?.UnparsedAddress?.replace(/#/g, 'Unit ');
    const city = listingSource?.City;
    const stateOrProvince = listingSource?.StateOrProvince;
    const postalCode = listingSource?.PostalCode;

    let propertyAddress = `${addressLineOne}, ${city}, ${stateOrProvince} ${postalCode}`;

    if (listingSource?.isCapcenterListing) {
      propertyAddress += " (CapCenter Listing)";
    }

    return propertyAddress;
  }

  async function renderListings() {
    const listingResponse = await getListings(props.custom.state);
    const listings = listingResponse.hits.hits;

    for (let i = 0; i < listings.length; i++) {

      let listItem =
        <li key={i}>
          <a href={getUrlWithUtmQueryString(buildListingURL(listings[i]._source))} target='_blank' rel='noreferrer noopener'>
            {buildListingLinkText(listings[i]._source)}
          </a>
        </li>;

      htmlListings.push(listItem);
    }

    setRenderedHtmlListings(htmlListings);
  }

  if (!initialized) {
    setInitialized(true);
    renderListings();
  }

  return (
    <React.Fragment>
      {(
        <AppWrapper>
          <>
            <AppHelmet
              custom={props.custom}
            />

            <div role="document">
              <main className={"locations container pb-4 " + (props.custom.code)} role="main">
                <article>
                  <header>
                    <div className={(props.custom.code)}>
                      <div className={"col-12" + (props.custom.code)}>
                        <h1>{props.custom.title}</h1>
                        <p>{props.custom.description}</p>
                      </div>
                    </div>
                  </header>

                  <section className={(props.custom.code)}>

                    <div className="row">
                      <div className="col-12 col-md-4">
                        <h3>Address</h3>
                        <p>
                          <a href="https://maps.app.goo.gl/55kcL2zkrHoTTg2w5" title="CapCenter branch office in McLean, VA" target="_blank" rel="noreferrer noopener">
                            1640 Boro Place
                            <br />
                            McLean, VA 22102
                          </a>
                        </p>
                        <p>
                          <a href="https://goo.gl/maps/1Yx1KLT4Vmgmwh7j6" title="CapCenter Baltimore branch office in Columbia, District of Columbia" target="_blank" rel="noreferrer noopener">
                            10320 Little Patuxent Pkwy Suite 200
                            <br />
                            Columbia, MD 21044
                          </a>
                        </p>
                      </div>
                      <div className="col-12 col-md-4">
                        <h3>Contact</h3>
                        <p>
                          <a href="/contact/best-mortgage-mclean-va">McLean, VA</a><br/>
                          <a href="tel:5716693559">
                            +1 (571) 669-3559
                          </a>
                        </p>
                        <p>
                          <a href="/contact/best-mortgage-columbia-md">Columbia, MD</a><br/>
                          <a href="tel:14108584991">
                            +1 (410) 858-4991
                          </a>
                        </p>
                        <p>
                          <a href="mailto:customerservice@capcenter.com">
                            customerservice@capcenter.com
                          </a>
                        </p>
                      </div>
                      <div className="col-12 col-md-4">
                        <h3>Hours</h3>
                        <p>
                          <a href="/contact/best-mortgage-mclean-va">McLean, VA</a><br/>
                          By appointment only
                        </p>
                        <p>
                          <a href="/contact/best-mortgage-columbia-md">Columbia, MD</a><br/>
                          By appointment only
                        </p>
                      </div>
                    </div>
                  </section>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        <h2>About CapCenter Mortgage in {props.custom.stateLongName}</h2>
                      </div>

                      <div className="col-12 col-md-8">
                        <p>
                          Washington DC is the capital of the United States of America located in the Eastern and Mid-Atlantic regions of the United States with a population of 712,816 in 2020. Washington DC is formerly known as the District of Columbia and is one of the best places to live in the United States of America because of its distinct seasons with mild temperatures.
                          CapCenter is proud to be located in the Washington, D.C. metropolitan area where many employees live, work, and enjoy. We host many activities for our employees and our clients on our DMV campuses in Northern Virginia and Maryland.
                        </p>

                        <p>
                          Washington, D.C. is one of the best places to live and work because of its proximity to shops, restaurants, parks, and businesses.

                          Our Washington, D.C. offices support
                          Washington, DC, DMV,
                          &nbsp;<a href="/contact/best-mortgage-mclean-va">Northern Virgina (NoVA)</a>,&nbsp;
                          &nbsp;<a href="/contact/best-mortgage-columbia-md">Maryland</a>,&nbsp;
                          Adams Morgan,
                          Anacostia, Brookland, Capitol Hill, Capitol Riverfront,
                          Columbia Heights, Congress Heights, Downtown, Dupont Circle, Foggy Bottom, Georgetown, H Street NE, Ivy City,
                          Logan Circle, Mount Vernon Square, National Mall, NoMa, Penn Quarter, Chinatown, Petworth, Shaw,
                          Southwest, The Wharf, U Street, Upper Northwest, Woodley Park, Northwest Washinigton, Navy Yard, Northeast Washington,
                          Tenleytown, Howard University, Kalorama, Southwest Waterfront, Truxton Circle, Brookland, Southwest Washington,
                          Federal Triangle, H Street Corridor, Embassy Row, Takoma, Naylor Gardens, Mount Vernon Triangle, Le Droit Park,
                          Deanwood, Lanier Heights, Capitol Riverfront, Brightwood Park, McLean Gardens, Eckington, Cathedral Heights, Sixteenth
                          Street Heights, Fort Dupont, Marshall Heights, Forest Hills, American University Park, Kalorama Heights,
                          Kingman Park, Bloomingdale, Shepherd Park,
                          and more.
                        </p>

                        <p>
                          {"Our mortgage professionals (licensed loan officers and home loan consultants) in " + props.custom.stateLongName + " are mortgage experts trained to guide you through the complicated loan underwriting process so you can close on time with Zero hassles. CapCenter offers conventional, HomeReady®, Home Possible, Jumbo, VA, FHA, and adjustable rate mortgage loan products."}
                        </p>

                        <p>
                          CapCenter specializes in no-fee and low-fee mortgages with low interest rates.
                          We may initially seem like we don't offer the best rates in the market, but many lenders charge additional fees for lower interest rates in the form of points and lender and non-lender closing costs. If you're looking for the lowest rate, try applying expected closing costs to pay down discount points with CapCenter. In an apples to apples comparison, <strong>we offer some of the best rates in the market and do not simply add closing costs into the loan balance</strong>. We are always striving to offer the best overall package for each of our clients' unique needs.
                          We encourage borrowers to not only look at interest rates and APR but also non-lender fees and terms when comparing loan estimates.
                          CapCenter helps borrowers get around closing costs by eliminating fees for borrowers for many popular home loan products.
                          Many of our most popular home loan products have <strong>no closing costs</strong> or <strong>zero closing costs</strong> mortgages, which are often the best mortgage options for <strong>first-time home buyers</strong> and for anyone that may sell or refinance before the loan term (commonly 30 years) because these options allow for more funds to be allocated to the down payment and these options also have less sunk costs associated with paying off the loan on sale of the property or refinancing the loan if interest rates drop.
                          Some of our products, such as the VA home loan for veterans, have <strong>zero down payment</strong> options for certain borrowers and conditions, such as borrowers with service-connected disabilities and appraisal value.
                          Another set of products, such as <a href="https://faq.capcenter.com/article/74-does-capcenter-offer-homeready-and-home-possible-products" target="_blank" rel="noreferrer noopener">HomeReady® and Home Possible</a>, have <strong>low down payment</strong> options for certain borrowers and conditions, such as first-time home buyers and income limits.
                          Our loan consultants can guide you through our loan products to find the best fit loan for your specific situation before and after you apply. We're dedicated to provide you fast and reliable services with our refined operational procedures. It'll feel like we're waiving closing costs, and the most frequently asked question after receiving a free quote is, "what's the catch?" That's our secret sauce, but we assure you that there is no catch and 95% of our past clients would recommend our services to friends and family.
                          In fact, we encourage you to shop around and compare loan estimates (it helps to compare rates, points, terms, mortgage insurance, lender closing costs, and non-lender closing costs as well) and any realty credits. Once we've gain your trust, we're here to help you purchase all your future homes, saving you time and money, over and over again.
                        </p>

                        <p>
                          {props.custom.isRealty ?
                            (<><p><a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/find-best-local-realtor`)} className={'d-flex btn-primary btn-sm'}>Find our best REALTORS® near {props.custom.stateLongName}</a></p><p><a href={getUrlWithUtmQueryString(`${baseRealtyUrl}/forms/request-realty`)} className={'d-flex btn-primary btn-sm'}>Schedule a consultation with a top-rated REALTOR® near {props.custom.stateLongName}</a></p></>) : ""}
                          {props.custom.isMortgage ?
                            (<a href={getUrlWithUtmQueryString(`${baseUrl}/apply-now/`)} className={'d-flex btn-primary btn-sm'}>Apply now for a mortgage in {props.custom.stateLongName}</a>) : ""}
                        </p>

                        <p>
                          <a href={getUrlWithUtmQueryString(`${baseUrl}/mortgage-rates/district-of-columbia`)} className={'d-flex btn-primary btn-sm'}>View our best mortgage interest rates today in {props.custom.stateLongName}</a>
                        </p>

                        <p>
                          <a href={getUrlWithUtmQueryString(`${baseUrl}/mortgage-calculator/purchase`)} className={'d-flex btn-primary btn-sm'}>Get a free, anonymous quote calculated to compare mortgage rates and closing costs in {props.custom.stateLongName}</a>
                        </p>

                        <p>&nbsp;</p>
                      </div>

                      <div className="col-12 col-md-4 mb-4">
                        <img src={ImageGlenAllenOffice} alt={'CapCenter HQ best mortgage home loan in Washington, D.C. lending company low fee zero closing cost'} />
                      </div>

                      <div className="col-12 image-gallery">
                        <img src={ImageGlenAllenVA} alt={props.custom.title + " best mortgage home loan in Washington, D.C. lender company low fee zero closing cost"} />
                        <img src={ImageRichmondRaceway} alt={props.custom.title + " RVA Richmond Raceway best mortgage home loan in Washington, D.C. lender company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVA2} alt={props.custom.title + " best mortgage home loan in Washington, D.C. lender company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 1 best mortgage home loan lender in Washington, D.C. company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay2} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 2 best mortgage home lender in Washington, D.C. company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay3} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 3 best mortgage home lender in Washington, D.C. company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAPieDay4} alt={props.custom.title + " RVA Richmond Glen Allen VA Pie Day 4 best mortgage home lender in Washington, D.C. company low fee zero closing cost"} />
                        <img src={ImageGlenAllenVAHalloweenTeam} alt={props.custom.title + " RVA Richmond Glen Allen VA in Washington, D.C. Halloween Winning Team best mortgage home loan lender company in Washington, D.C."} />
                        <img src={ImageGlenAllenVAHalloween} alt={props.custom.title + " Halloween best mortgage home loan lender company in Washington, D.C."} />
                        <img src={ImageSmores} alt={props.custom.title + " S'mores Day best mortgage home loan lender company in Washington, D.C. low fee zero closing cost"} />
                        <img src={ImageSmores2} alt={props.custom.title + " S'mores Day best mortgage home loan lender company in Washington, D.C. low fee zero closing cost"} />
                      </div>
                    </div>
                  </section>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        <img src={ImageCapCenterHQ} alt={props.custom.title + " best mortgage home loan in Washington, D.C. lender high quality low fee zero closing costs"} width={'500px'}/>
                      </div>
                    </div>
                  </section>

                  <section className={(props.custom.code)}>
                    <div className="row">
                      <div className="col-12">
                        <h4>
                          <a href={`${baseRealEstateUrl}/homes/location/city/washington-dc`} target="_blank" rel="noreferrer noopener">
                          Homes for Sale in {props.custom.stateLongName}
                          </a>
                        </h4>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <ol>
                          {renderedHtmlListings}
                        </ol>
                      </div>
                    </div>
                  </section>

                </article>
              </main>
            </div>
          </>
        </AppWrapper>
      )}
    </React.Fragment>
  );
}

export default State;
